import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/autoplay";

const teamMembers = [
    {
        nom: "Kossi Fimin ADOBAH",
        fonction: "Gérant",
        role: "Stratégie & Vision",
        image: "/assets/team/team1.jpg",
    },
    {
        nom: "Emmanuel AMEDJROVI",
        fonction: "Responsable Comercial",
        role: "Communication & Promotion",
        image: "/assets/team/team2.jpg",
    },
    {
        nom: "M. NZEGO Henri KALAMBAYI",
        fonction: "CEO",
        role: "",
        image: "/assets/team/team3.jpg",
    },
    {
        nom: "Mlle Akouavi Essenam ADOBAH",
        fonction: "CFO",
        role: "",
        image: "/assets/team/team2.jpg",
    },
    {
        nom: "M. Amedzeame CODJIE-ABOTSI",
        fonction: "Technical Supervisor",
        role: "Support & Satisfaction",
        image: "/assets/team/team4.jpg",
    },
];

export default function TeamCarousel() {
    return (
        <section className="py-5 bg-light">
            <div className="container">
                <h2 className="text-center fw-bold mb-5">Notre Équipe</h2>

                <Swiper
                    modules={[Autoplay, EffectCoverflow]}
                    effect={"coverflow"}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={"auto"}
                    autoplay={{ delay: 3000 }}
                    loop={true}
                    coverflowEffect={{
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        modifier: 1,
                        slideShadows: true,
                    }}
                >
                    {teamMembers.map((member, index) => (
                        <SwiperSlide
                            key={index}
                            style={{ width: "250px", height: "330px" }}
                            className="team-slide"
                        >
                            <div className="team-card">
                                <div className="team-front">
                                    <img
                                        src={member.image}
                                        alt={member.nom}
                                        className="w-100 h-100 object-fit-cover rounded"
                                    />

                                </div>
                                <div className="team-back d-flex flex-column justify-content-center align-items-center text-white">
                                    <h5 className="fw-bold">{member.nom}</h5>
                                    <p className="mb-1">{member.fonction}</p>
                                    <small className="text-light">{member.role}</small>
                                </div>

                            </div>
                        </SwiperSlide>

                    ))}
                </Swiper>

            </div>

            <style>{`
        .team-card {
          position: relative;
          width: 100%;
          height: 100%;
          transform-style: preserve-3d;
          transition: transform 0.8s;
        }

        .team-slide:hover .team-card {
          transform: rotateY(180deg);
        }

        .team-front,
        .team-back {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 12px;
          backface-visibility: hidden;
        }

        .team-front img {
          border-radius: 12px;
          object-fit: cover;
        }

        .team-back {
          background: linear-gradient(135deg, #1c1c1e, #343a40);
          transform: rotateY(180deg);
          text-align: center;
          padding: 20px;
        }
      `}</style>
        </section>
    );
}
